import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { Outlet, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useBranding } from '../contexts/BrandingContext';
import Navigation from './Navigation';
import './Layout.css';

// Default neutral colors
const defaultColors = {
  primary: '#2c3e50',
  secondary: '#34495e'
};

function Layout() {
  const { user, logout } = useAuth();
  const { companyName, primaryColor, secondaryColor, logoUrl } = useBranding();
  const navigate = useNavigate();

  if (!user) {
    return <Navigate to="/login" />;
  }

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  // Use companyName from branding if available, otherwise fall back to customerName
  const displayName = companyName || user?.customerName || 'Customer Portal';

  // Convert color to RGB for transparency
  const getRGBA = (hex, alpha) => {
    if (!hex) return `rgba(44, 62, 80, ${alpha})`; // Default dark blue-grey
    try {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } catch (error) {
      return `rgba(44, 62, 80, ${alpha})`; // Default on error
    }
  };

  const sidebarStyle = {
    background: secondaryColor || `linear-gradient(180deg, ${defaultColors.primary} 0%, ${defaultColors.secondary} 100%)`
  };

  const logoContainerStyle = {
    backgroundColor: getRGBA(primaryColor || defaultColors.primary, 0.3)
  };

  return (
    <div className="layout-container">
      <div className="sidebar" style={sidebarStyle}>
        <div className="logo-container" style={logoContainerStyle}>
          <img 
            src={logoUrl || "/globe2.png"} 
            alt={logoUrl ? `${displayName} logo` : "Globe"} 
            className="nav-logo"
            style={logoUrl ? { width: 'auto', maxWidth: '150px' } : undefined}
          />
          <span className="customer-name">{displayName}</span>
          <button 
            onClick={handleLogout} 
            className="logout-btn"
            style={{
              marginLeft: 'auto',
              padding: '8px',
              minWidth: 'auto'
            }}
          >
            <FontAwesomeIcon icon={faSignOutAlt} />
          </button>
        </div>
        <div className="nav-content">
          <Navigation />
        </div>
      </div>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
